'use client';

import { Toaster as Sonner, toast } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-xl group-[.toaster]:rounded-md font-sans',
          description: 'group-[.toast]:text-muted-foreground text-xs',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-semibold',
          cancelButton:
            'group-[.toast]:bg-secondary group-[.toast]:text-foreground',
          success:
            'group-[.toast]:border-primary/50 group-[.toast]:text-primary-foreground',
          error:
            'group-[.toast]:border-destructive/60 group-[.toast]:text-destructive-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
